module.exports = __webpack_public_path__ + "img/jht-icon-02.b7d6b427.png";